import * as React from "react";
import { withStyles, WithStyles, Theme, createStyles, StyleRulesCallback } from "../mui/styles";
import classNames from 'classnames';
import DataGridBodyCell from "./DataGridBodyCell";
import { TableRow } from "../widget";
import { BodyColumn, DataGridLines, DataGridPadding } from "./Types";

export interface DataGridBodyRowProps<T> {
    columns: BodyColumn<T>[];
    row: T,
    gridLines?: DataGridLines;
    lastRow: boolean;
    padding?: DataGridPadding;
    onClickRow?: (row: T) => void;
}

declare type Props<T> = DataGridBodyRowProps<T> & WithStyles<typeof styles>;

class DataGridBodyRow<T> extends React.PureComponent<Props<T>> {

    private onClick = (event: React.MouseEvent<HTMLElement>) => {
        const { onClickRow, row } = this.props;
        onClickRow && onClickRow(row);
    }

    render() {
        const { classes, columns, row, gridLines, lastRow, padding } = this.props;

        const rowClassName = classNames({
            [classes.root]: true,
            [classes.padding]: padding && padding !== 'default',
        })

        return <TableRow hover className={rowClassName} >
            {columns.map((c, k) => <DataGridBodyCell key={k} {...c} firstCol={k === 0} row={row} gridLines={gridLines} lastRow={lastRow} padding={padding} onClick={this.onClick} />)}
        </TableRow>;
    }
}

const styles = ((theme: Theme) => {

    return createStyles({

        root: {
        },

        padding: {
            height: 0,
        },
    })
}) as StyleRulesCallback;

export default withStyles(styles, { name: 'DataGridBodyRow' })(DataGridBodyRow);
